import React, { useState, useEffect } from 'react';
import Header from '../components/Header';

const subjectCategories = {
  'English': ['English 9 ', 'English 10', 'Creative Writing', 'AP Lang'],
  'Math': ['Algebra 1', 'Algebra 2', 'H Algebra 2', 'Geometry', 'Pre-Calc', 'H Pre-Calc', 'AP CalculusAB', 'AP Statistics'],
  'Science': ['Biology', 'Chemistry', 'Chemistry AP', 'Chemistry H', 'Physics', 'AP Environmental Science', 'AP Computer Science - Principles'],
  'Humanities': ['US History', 'AP US History', 'AP Euro', 'AP Human Geography', 'World History', 'MUN', 'AP Psychology'],
  'Languages': ['Spanish', 'AP Spanish', 'French'],
  'Middle School': ['Middle School English', 'Middle School Math', 'Middle School Pre-Algebra', 'Middle School Algebra', 'Middle School Biology', 'Middle School History', 'Middle School Spanish'],
  'Elementary School': ['Elementary School']
};
const times = ['Weekday 2-5 pm', 'Weekday 5-7 pm', 'Weekday after 7 pm', 'Weekends', 'Other'];

export default function TutorRegister() {
  const [form, setForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    schoolEmail: '',
    subjects: [],
    time: times[0],
    gender: '',
    csf: '',
    comments: '',
    gradYear: '',
    requestedSubjects: '',
    highSchool: ''
  });
  const [submitted, setSubmitted] = useState(false);

  // Track page view with Google Analytics
  useEffect(() => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('config', 'G-CC8DD4BS2W', {
        page_path: '/tutor-register',
        page_title: 'Tutor Registration'
      });
    }
  }, []);

  function handleChange(e) {
    const { name, value, type, checked } = e.target;
    if (name === 'subjects') {
      if (checked) {
        setForm({ ...form, subjects: [...form.subjects, value] });
      } else {
        setForm({ ...form, subjects: form.subjects.filter(s => s !== value) });
      }
    } else {
      setForm({ ...form, [name]: value });
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      // Set school and program based on high school selection
      let school = '';
      let program = '';
      
      if (form.highSchool === 'Mira Costa') {
        school = 'Costa';
      } else if (form.highSchool === 'Lawndale') {
        school = 'Lawndale HS';
        program = 'JA';
      } else if (form.highSchool === 'Leuzinger') {
        school = 'Leuzinger HS';
        program = 'WR';
      } else if (form.highSchool === 'SMC') {
        school = 'SMC';
        program = 'SMC';
      }
      
      const res = await fetch('/api/tutors', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...form, subjects: form.subjects, school, program }),
      });
      if (res.ok) {
        setSubmitted(true);
      } else {
        alert('Error registering tutor. Please try again.');
      }
    } catch (err) {
      alert('Could not connect to the server.');
    }
  }

  if (submitted) {
    return (
      <div>
        <Header />
        <div style={{ padding: '2rem', textAlign: 'center' }}>
          <h2>Thank you for registering as a tutor!</h2>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Header />
      <div style={{ padding: '1rem', background: '#f7f9fb', minHeight: '100vh' }}>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '3rem', marginBottom: '3rem' }}>
          <div style={{ background: '#fff', borderRadius: 18, maxWidth: 720, padding: '2.5rem', textAlign: 'center', fontSize: '1.05em' }}>
            <h1 style={{ fontSize: 'clamp(1.5rem, 4vw, 2.5rem)', fontWeight: 800, marginBottom: 18, letterSpacing: 1, color: '#111' }}>Tutor Registration</h1>
            <p style={{ textAlign: 'center' }}>
              Please make sure your name and school email address are accurate so we can verify that you are a student at this school. We will use your gmail address to communicate with you. Note: Applications are only being accepted from CSF and NHS honor societies.
            </p>
            <form onSubmit={handleSubmit}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', marginBottom: '1rem' }}>
                <div style={{ flex: 1 }}>
                  <label>First Name*<br /><input name="firstName" value={form.firstName} onChange={handleChange} required /></label>
                </div>
                <div style={{ flex: 1 }}>
                  <label>Last Name*<br /><input name="lastName" value={form.lastName} onChange={handleChange} required /></label>
                </div>
              </div>
              <div style={{ marginBottom: 16 }}>
                <label>Email (Gmail)*<br /><input name="email" type="email" value={form.email} onChange={handleChange} required style={{ width: '100%' }} /></label>
              </div>
              <div style={{ marginBottom: 16 }}>
                <label>School Email*<br /><input name="schoolEmail" type="email" value={form.schoolEmail} onChange={handleChange} required style={{ width: '100%' }} /></label>
                <small style={{ fontSize: '1em' }}>We will use this email to verify that you are a student.</small>
              </div>
              <div style={{ marginBottom: 16 }}>
                <label>Graduation Year*<br />
                  <select name="gradYear" value={form.gradYear} onChange={handleChange} required style={{ width: '100%' }}>
                    <option value="">Select Year</option>
                    <option value="2026">2026</option>
                    <option value="2027">2027</option>
                    <option value="2028">2028</option>
                    <option value="2029">2029</option>
                  </select>
                </label>
              </div>
              <div style={{ marginBottom: 16 }}>
                <label>What school do you attend?*<br />
                  <select name="highSchool" value={form.highSchool} onChange={handleChange} required style={{ width: '100%' }}>
                    <option value="">Select School</option>
                    <option value="Mira Costa">Mira Costa</option>
                    <option value="Lawndale">Lawndale</option>
                    <option value="Leuzinger">Leuzinger</option>
                    <option value="SMC">SMC</option>
                  </select>
                </label>
              </div>
              <div style={{ marginBottom: 16 }}>
                <label>Subjects you would like to tutor<br />
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    {Object.entries(subjectCategories).map(([category, subjects]) => (
                      <div key={category} style={{ border: '1px solid #e0e0e0', borderRadius: '8px', padding: '12px' }}>
                        <div style={{ fontWeight: 'bold', marginBottom: '8px', color: '#333', fontSize: '1em' }}>
                          {category}
                        </div>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                          {subjects.map(subject => (
                            <label key={subject} style={{ marginRight: '12px', fontSize: '0.9em' }}>
                              <input
                                type="checkbox"
                                name="subjects"
                                value={subject}
                                checked={form.subjects.includes(subject)}
                                onChange={handleChange}
                                style={{ marginRight: '4px' }}
                              /> {subject}
                            </label>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </label>
              </div>
              <div style={{ marginBottom: 16, textAlign: 'left', fontSize: '0.95em', color: '#333' }}>
                <div style={{ marginBottom: 6, fontWeight: 500 }}>
                  Add any classes below that you would like to tutor that are not an option in the list above. Leave the box blank if you do not have any subjects to add.
                </div>
                <textarea
                  name="requestedSubjects"
                  value={form.requestedSubjects}
                  onChange={handleChange}
                  rows={2}
                  style={{ width: '100%', fontSize: '1em', borderRadius: 6, border: '1px solid #ccc', padding: 8 }}
                  placeholder="New subjects (optional)"
                />
              </div>
              <div style={{ marginBottom: 16 }}>
                <label>What time will you typically like to tutor?<br />
                  <select name="time" value={form.time} onChange={handleChange} style={{ width: '100%' }}>
                    {times.map(t => <option key={t} value={t}>{t}</option>)}
                  </select>
                </label>
              </div>
              <div style={{ marginBottom: 16 }}>
                <label>What is your gender?<br />
                  <label><input type="radio" name="gender" value="Male" checked={form.gender === 'Male'} onChange={handleChange} required /> Male</label>{' '}
                  <label><input type="radio" name="gender" value="Female" checked={form.gender === 'Female'} onChange={handleChange} required /> Female</label>
                </label>
              </div>
              <div style={{ marginBottom: 16 }}>
                <label>Are you a member of CSF or National Honor Society (NHS)?<br />
                  <label><input type="radio" name="csf" value="CSF" checked={form.csf === 'CSF'} onChange={handleChange} required /> CSF</label>{' '}
		  <label><input type="radio" name="csf" value="NHS" checked={form.csf === 'NHS'} onChange={handleChange} required /> NHS</label>{' '}
                  <label><input type="radio" name="csf" value="Neither" checked={form.csf === 'Neither'} onChange={handleChange} required /> Neither</label>
                </label>
              </div>
              <div style={{ marginBottom: 16 }}>
                <label>Any comments or questions?<br />
                  <textarea name="comments" value={form.comments} onChange={handleChange} rows={3} style={{ width: '100%', fontSize: '1em' }} />
                </label>
              </div>
              <button type="submit" style={{ background: '#04d664', color: 'white', border: 0, borderRadius: 24, padding: '0.75rem 3rem', fontSize: '2.25rem', cursor: 'pointer' }}>Submit</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
